import styles from "./ExpirationWarmup.module.scss"
import useStrings from "../../../localization/useStrings"
import ExpirationPricingSelection from "../ExpirationPricingSelection/ExpirationPricingSelection"
import UltimateBackground from "../../../components/UltimateBackground/UltimateBackground"
import svg from "../../../utils/svg"
import images from "../../../utils/images"
import { useExpiration } from "../../../context/expirationContext"
import ToggleUltimateButton from "../ToggleUltimateButton/ToggleUltimateButton"
import ExpirationComparePlansButton from "../ExpirationComparePlansButton/ExpirationComparePlansButton"

interface Feature {
  title: string
  subtitle: string
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

const ExpirationWarmup = () => {
  const { state } = useExpiration()

  const strings = useStrings().expiration.warmup
  const hideWarmup = useExpiration().actions.hideWarmup

  const title = state.canToggleUltimate
    ? strings.titlePremium
    : strings.titleUltimate

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <ExpirationComparePlansButton className={styles.comparePlans} />
        <button className={styles.closeButton} onClick={hideWarmup}>
          {strings.close}
        </button>
      </div>
      <div className={styles.icon}>
        {state.isUltimate ? <svg.UltimateIcon /> : <svg.PremiumIcon />}
      </div>
      <label className={styles.title}>{title}</label>
      <label className={styles.subtitle}>{strings.subtitle}</label>
      <FeatureList />
      <label className={styles.footer}>{strings.footer}</label>
      <ExpirationPricingSelection />
      <ToggleUltimateButton />
      {state.isUltimate && <UltimateBackground forceVisible />}
      <div
        className={`${styles.expirationPattern} ${images.expirationPattern.class}`}
      />
    </div>
  )
}

const FeatureList = () => {
  const strings = useStrings().expiration.warmup
  const isUltimate = useExpiration().state.isUltimate

  const premiumFeatures = [
    {
      ...strings.features.cloudVault,
      icon: svg.featureIcons.CloudVault,
    },
    {
      ...strings.features.reviews,
      icon: svg.featureIcons.Star,
    },
    {
      ...strings.features.noAds,
      icon: svg.featureIcons.Adfree,
    },
  ]

  const ultimateFeatures = [
    {
      ...strings.features.cloudVaultUltimate,
      icon: svg.featureIcons.CloudVault,
    },
    {
      ...strings.features.reviews,
      icon: svg.featureIcons.Star,
    },
    {
      ...strings.features.organizationPlus,
      icon: svg.featureIcons.OrganizationPlus,
    },
  ]

  const features = isUltimate ? ultimateFeatures : premiumFeatures

  return (
    <div className={styles.featuresContainer}>
      {features.map((feature, index) => (
        <FeatureListItem key={index} feature={feature} />
      ))}
    </div>
  )
}

interface FeatureListItemProps {
  feature: Feature
}

const FeatureListItem = ({ feature }: FeatureListItemProps) => {
  return (
    <div className={styles.featureItem}>
      <div className={styles.featureIconContainer}>
        {<feature.icon className={styles.featureIcon} />}
      </div>
      <div className={styles.featureItemTextContainer}>
        <label className={styles.featureTitle}>{feature.title}</label>
        <label className={styles.featureSubtitle}>{feature.subtitle}</label>
      </div>
    </div>
  )
}

export default ExpirationWarmup
